import { HospitalModel } from './hospital.model';
import { FacultyModel } from './faculty.model';
import { ProgramCategoryModel } from './program_category.model';

export class UserModel {
	Id: string;
	FirstName: string;
	LastName: string;
	MiddleName: string;
	FullName: string;
	PhoneNumber: string;
	Email: string;
	About: string;
	FacultyId: string;
	ProgramCategoryId: number;
	ProgramCategoryName: string;
	FacultyName: string;
	FacultySpecialisationId: string;
	YearGroupId: string;
	YearGroupName: string;
	ResidentId: string;
	HospitalId: number;
	UserName: string;
	Password: string;
	ConfirmPassword: string;
	UserRole: string;
	ProfileImageSmallUrl: string;
	ProgramCategory: ProgramCategoryModel;
	Faculty: FacultyModel;
	Hospital: HospitalModel;
	HospitalName: string;
	FacultyContinuousAssessmentFormId: string;
}
